import { render } from "./FlexSlider2.vue?vue&type=template&id=864ca4c6&scoped=true"
import script from "./FlexSlider2.vue?vue&type=script&lang=js"
export * from "./FlexSlider2.vue?vue&type=script&lang=js"

import "./FlexSlider2.vue?vue&type=style&index=0&id=864ca4c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864ca4c6"]])

export default __exports__